var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.onSale)?_c('div',[_vm._v(" Yayında ")]):_c('div',[_vm._v(" Yayında Değil ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }